module.exports = __webpack_public_path__ + "img/img_24.5f9c8b10.png";